import * as Sentry from '@sentry/browser'
import ls from './localStorage'

const { appData, id = 'test', server = 'localhost' } = ls.getItem('appData') || {}

if (window.location.protocol === 'https:') {
  Sentry.init({ dsn: 'https://ffaa75922292469495f9038ecc42af84@sentry.io/3474067' })
}

/**
 * Retorna o prefixo para montar os requests na api
 */
const isTesting = window.location.search.indexOf('test=true') !== -1
export function getPrefix() {
  let finderId
  let finderServer

  finderId = window.appData?.id ?? appData?.id ?? id
  finderServer =
    window.appData?.server ?? appData?.server ?? process.env.PRODUCT_FINDER_ENV ?? server

  if (!process.env.PRODUCT_FINDER_ENV) {
    if (process.env.NODE_ENV === 'production') {
      return ''
    }
  } else {
    if (!finderId) {
      throw new Error('use changeAppData(widgetDomain, server)')
    }

    if (!serverOptions.includes(finderServer)) {
      throw new Error(`Precisa ser uma das opções: ${serverOptions}`)
    }

    if (finderServer === 'localhost') {
      return `http://localhost:3000/dev/productfinder/${finderId}`
    }
  }
  return `https://${finderId}.${finderServer}`
}

const serverOptions = [
  'localhost',
  'ondetem.app', // x
  'aquiperto.app', // stage
  'pertinhodemim.com', // prod
  'pertinhodemim.app' // dev
]

/**
 * @param {string} id widgetDomain
 * @param {string} server one of serverOptions
 */
async function changeAppData(id, server = 'localhost') {
  if (!serverOptions.includes(server)) {
    throw new Error(`Precisa ser uma das opções: ${serverOptions}`)
  }

  console.log(`changeAppData`, id, server)
  const url =
    server === 'localhost'
      ? `http://localhost:3000/dev/productfinder/${id}/widget`
      : `https://${id}.${server}/widget`

  try {
    const response = await fetch(url)
    const { company } = await response.json()

    ls.setItem('appData', { appData: company, id, server })
    window.location.reload()
  } catch (error) {
    console.log('Error fetch widgetDomain', error.message)
  }
}

const defaultWidgetConfig = {
  searchPlaceholder: 'Busque conhecimento',
  colorPrimary: '#fffff',
  featured: [
    { limitDate: null, gtin: '789611000790', type: 'default', order: 0 },
    { limitDate: '2019-11-01', gtin: '7898139872864', type: 'default', order: 1 },
    { limitDate: null, gtin: '789834432171', type: 'default', order: 2 }
  ],
  brandName: 'GOFIND.ONLINE',
  gtag: '3',
  buyOnline: 'fixedLink',
  fixedLink: 'http://www.google.com',
  anyProducts: 'footer',
  hideProductsList: false,
  ageGateMessage: 'Teste',
  citysAllowedRappi: ['São Paulo-SP'],
  hideRetailButton: false,
  buyWithRappi: true,
  ageGate: false,
  ageGateRedirect: 'http://google.com',
  cnpj: '23809139000186',
  availabilityTimeFactor: 1,
  storesNameViewFormat: 'none',
  language: 'pt-BR'
}

/**
 * Aqui injeta appData no window, que será usado depois no init do redux
 */
if (process.env.NODE_ENV !== 'production') {
  if (id) {
    console.warn(`🐬 Widget: %s; 🐬 Server: %s;`, id, server)
  }
}

window.appData = window.appData || appData || defaultWidgetConfig

// injeta no window para poder invokar do console
window.changeAppData = changeAppData

export const env = {
  PREFIX: getPrefix(),
  HERE_REST_APIKEY: 'b1hR3ARAzvx_guVuvXNWOo0WgN75CWy0dqMD0COBSBQ',
  TEST_MODE: isTesting
}
